import React from "react";
import { useTranslation } from "react-i18next";
import { SeatZoneGridStyled } from "./styled";
import { SEAT_STATE_STYLE } from "utils/functions/seatBooking";

// ผังสถานะทั้งโซน (S2 design): แถวละบรรทัด ด้านบน = ใกล้เวที แตะที่นั่งว่างเพื่อเลือก
// ถ้าที่นั่งมี col (ตำแหน่งจาก Excel) วางตามช่องนั้นให้เว้นทางเดิน/เยื้องเหมือนผังจริง ไม่มี col จัดแถวกึ่งกลาง
// seats: [{ seat_id, row, seat_no, col, state }] state = free | mine | pending | taken
const SeatZoneGrid = ({ title, badge, badgeColor, seats, onToggle }) => {
  const { t } = useTranslation(["seat"]);
  const rows = seats.reduce((result, seat) => {
    (result[seat.row] = result[seat.row] || []).push(seat);
    return result;
  }, {});
  const rowNames = Object.keys(rows).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
  const hasCol = seats.some((seat) => seat.col);
  const positionOf = (seat) => seat.col || seat.seat_no;
  const maxCol = hasCol ? Math.max(...seats.map(positionOf)) : 0;

  return (
    <SeatZoneGridStyled>
      <div className="zg_header">
        <span className="zg_badge" style={{ background: badgeColor }}>
          {badge}
        </span>
        <span className="zg_title">{title}</span>
      </div>
      <div className="zg_stage">▲ {t("Stage", { ns: "seat" })}</div>
      <div className="zg_scroll">
        <div className="zg_rows">
          {rowNames.map((rowName) => (
            <div
              className={`zg_row${hasCol ? " by_col" : ""}`}
              key={rowName}
              style={hasCol ? { gridTemplateColumns: `var(--row-label) repeat(${maxCol}, var(--cell))` } : undefined}
            >
              <div className="zg_row_label">{rowName}</div>
              <div className={hasCol ? "zg_seats_contents" : "zg_seats"}>
                {rows[rowName]
                  .sort((a, b) => a.seat_no - b.seat_no)
                  .map((seat) => {
                    const style = SEAT_STATE_STYLE[seat.state] || SEAT_STATE_STYLE.taken;
                    const tappable = seat.state === "free" || seat.state === "mine";
                    return (
                      <button
                        type="button"
                        key={seat.seat_id}
                        className="zg_seat"
                        style={{
                          background: style.bg,
                          color: style.color,
                          gridColumn: hasCol ? positionOf(seat) + 1 : undefined,
                        }}
                        disabled={!tappable}
                        aria-label={`${seat.seat_id} ${t(style.labelKey, { ns: "seat" })}`}
                        onClick={() => tappable && onToggle(seat)}
                      >
                        {seat.seat_no}
                      </button>
                    );
                  })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </SeatZoneGridStyled>
  );
};

export default SeatZoneGrid;
